<template>
  <div id="cardContentRayonX">
    <div class="cardContentRayonX_title">
      L’optimiseur de frais
    </div>
    <div class="mt-3">Vos frais de gestion : Moyenne de <span class="txt_purple">{{ Number(total_management_fees_overall/sum_assets).toFixed(2) }}%</span> / an soit <span class="txt_purple">{{ formatEuros(total_management_fees_overall) }} € </span></div>
    <div class="mt-3" v-if="average_management_fees != 0">
      Vous faites mieux que <span class="txt_purple">{{getUserRanking()}} %</span> de nos utilisateurs
      <mf_star_rating
        :star="this.starNum"
        starsize="2x"
      />
    </div>
    <div class="mt-3">Frais de gestion potentiel : <span class="txt_purple">{{ formatEuros(total_savings) }}€</span> / an soit un gain de <span class="txt_purple">{{ formatEuros(total_savings * 25) }}€</span> sur 25 ans</div>
    <div class="mt-3">
      <b-button href="/scan/diagnostic/fees" class="btnCardContent">
        Analyser mes frais de gestion
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["average_management_fees_user", "average_management_fees", "total_savings", "total_fees", "sum_assets", "total_management_fees_overall"],
  data() {
    return {
      starNum: 0
    };
  },
  methods: {
    getUserRanking()
    {
      let percentage = Number(this.average_management_fees_user / this.average_management_fees).toFixed(2);
      this.starNum = Math.round(percentage*5/100);
      console.log(this.starNum);
      return this.$utils.numberWithSpaces(percentage);
    },
    formatEuros(number)
    {
      return this.$utils.numberWithSpaces(Number(number).toFixed(0));
    },
  }
};
</script>
